import {useContext} from 'react';

// @ts-expect-error - TS2614 - Module '"src/stores/index"' has no exported member 'IndexStore'. Did you mean to use 'import IndexStore from "src/stores/index"' instead?
import {IndexStore} from 'src/stores/index';
import {FluxContext} from './root';


export default function useFluxStore(): typeof IndexStore {
  const {store} = useContext(FluxContext);
  return store;
}
